import { Area } from './types/Area';

export const isInRange = (area: Area, range: Area) => {
    return area.x >= range.x
        && area.y >= range.y
        && area.x + area.width <= range.x + range.width
        && area.y + area.height <= range.y + range.height;
};